import { QuestionSectionWrapper } from "@/components/features/items/edit/_shared/ui/components/system/question/_layouts/item-wrapper";

import { InputNumberField } from "@/components/ui/form/fields/input-field/input-number";

import { useVoucherIntervalPrepDates } from "./hooks";

export const QuestionVoucherIntervalPrepDates = () => {
	const { shouldShowIntervalPrepDatesSection, intervalPrepDates, onSetIntervalPrepDates } =
		useVoucherIntervalPrepDates();

	return (
		<>
			{shouldShowIntervalPrepDatesSection && (
				<QuestionSectionWrapper>
					<p>購入してから</p>
					<InputNumberField
						value={intervalPrepDates?.value ?? undefined}
						errorMessage={intervalPrepDates?.error}
						handleInput={onSetIntervalPrepDates}
						hiddenSpinButton={false}
					/>
					<p>日後に利用可能</p>
				</QuestionSectionWrapper>
			)}
		</>
	);
};

QuestionVoucherIntervalPrepDates.displayName = "QuestionVoucherIntervalPrepDates";
